import { render, staticRenderFns } from "./AverageValues.vue?vue&type=template&id=5d4d186e&scoped=true&"
import script from "./AverageValues.vue?vue&type=script&lang=js&"
export * from "./AverageValues.vue?vue&type=script&lang=js&"
import style0 from "./AverageValues.vue?vue&type=style&index=0&id=5d4d186e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4d186e",
  null
  
)

export default component.exports